import React, { useContext, useState } from 'react';

import UploadMultipleVideos from './UploadMultipleVideos';
import UploadSingleVideo from './UploadSingleVideo';

//mui imports====
import { Box } from '@mui/system';
import useStyles from '../../styles';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Modalv2Context } from '../../../../Contexts/Modalv2Context';
//===============

const CreateVideoModal = React.forwardRef(({ categories }) => {
	const classes = useStyles();
	const { blockClosingFeature, updateBlockClosingFeature } = useContext(Modalv2Context);
	const [uploadVideoMode, setUploadVideoMode] = useState('SINGLE'); // there would be 2 modes 'SINGLE'

	return (
		<Box className={classes.modalContentStyle}>
			<TabContext value={uploadVideoMode} style={{ border: '2px solid blue' }}>
				<TabList
					onChange={(event, newValue) => {
						setUploadVideoMode(newValue);
					}}
					style={{ width: 'fit-content', margin: '0 auto' }}
				>
					<Tab label="Upload Single Video" value="SINGLE" />
					<Tab label="Upload Multiple Video" value="MULTIPLE" />
				</TabList>

				<TabPanel value="SINGLE">
					<UploadSingleVideo
						categories={categories}
						videoUploadsOngoing={blockClosingFeature}
						setVideoUploadsOngoing={updateBlockClosingFeature}
					/>
				</TabPanel>
				<TabPanel value="MULTIPLE">
					<UploadMultipleVideos
						categories={categories}
						videoUploadsOngoing={blockClosingFeature}
						setVideoUploadsOngoing={updateBlockClosingFeature}
					/>
				</TabPanel>
			</TabContext>
		</Box>
	);
});

export default CreateVideoModal;
